import { Passenger } from "./passenger.model";

export class Location {
    id?: number;
    name?: string;
    address?: string;
    geoLocation?: {
        lng: number,
        lat: number
    };
    owner?: Passenger;
    routes?: any[];
    domain?: number;
}